import { useState } from "react";
import styles from "../styles.module.css";
import eyeOff from "../../../assets/icons/eye-off.svg";
import eye from "../../../assets/icons/eye.svg";

type Props = {
  title: string;
  placeholder?: string;
  value?: any;
  customValidity?: string;
  setter?: Function;
  hideAsterisk?: boolean;
};

const CampoSenha = ({
  title,
  placeholder,
  value,
  customValidity,
  setter,
  hideAsterisk,
}: Props) => {
  const [showPassword, shouldShowPassword] = useState(false);

  return (
    <div className={styles.campo}>
      <label>
        {title}
        <span className={styles.required}>{!hideAsterisk && "*"}</span>:
      </label>
      <div className={styles.icon}>
        <input
          type={showPassword ? "text" : "password"}
          value={value}
          placeholder={placeholder}
          maxLength={128}
          required
          onInvalid={(e) => {
            if (customValidity) {
              e.currentTarget.setCustomValidity(customValidity);
            }
          }}
          onChange={(e) => {
            if (setter) {
              const v = e.target.value;
              setter(v);
              e.currentTarget.setCustomValidity("");
            }
          }}
        />

        <img
          src={showPassword ? eye : eyeOff}
          alt="Senha ocultada"
          onClick={() => {
            shouldShowPassword(!showPassword);
          }}
        />
      </div>
    </div>
  );
};

export default CampoSenha;
